import React from 'react';
import { Box, Flex, Text } from 'rebass';
import TimelineItemRail from './TimelineItemRail';
import { buildFooterText } from './helpers';
import TimelineItem from './TimelineItem';
import { HistoryItem } from './types';

type TimelineDayProps = {
  dayIndex: number;
  dayFormatted: string;
  isFirstDate: boolean;
  isLastDate: boolean;
  noRail?: boolean;
  historyItems: HistoryItem[];
};

const TimelineDay: React.FC<TimelineDayProps> = ({
  dayIndex,
  dayFormatted,
  isFirstDate,
  isLastDate,
  noRail = false,
  historyItems,
}) => {
  return (
    <Box key={dayIndex}>
      <Box
        fontSize="13px"
        lineHeight="13px"
        fontStyle="italic"
        textAlign="center"
        flexGrow={1}
      >
        {dayFormatted}
      </Box>

      <Flex flexDirection="column" mt={2} sx={{ gap: 5 }}>
        {historyItems.map((historyItem, itemIndex) => {
          const computedFooterText: string | undefined =
            buildFooterText(historyItem);
          // if (
          //   historyItems[itemIndex + 1] &&
          //   buildFooterText(historyItems[itemIndex + 1]) ===
          //     computedFooterText
          // ) {
          //   computedFooterText = undefined
          // }

          const isFirst = itemIndex === 0;
          const isLast = itemIndex + 1 === historyItems.length;
          const isInitial = isFirst && isFirstDate;
          const isFinal = isLast && isLastDate;

          return (
            <>
              <TimelineItem
                key={historyItem.id}
                noRail={noRail}
                isInitial={isInitial}
                isFirst={isFirst}
                isLast={isLast}
                isFinal={isFinal}
                footer={computedFooterText}
                {...historyItem}
              />
            </>
          );
        })}
      </Flex>
    </Box>
  );
};

export default TimelineDay;
